/**
 * Actions have a type that where the name will show up in logs.
 */
export enum DevicesActions {
  getDevices = 'devices/get-devices',
  getDevicesResponse = 'devices/get-devices/success',
  getDevicesFailed = 'devices/get-devices/failed',
  disableDevice = 'devices/disable-device',
  disableDeviceResponse = 'devices/disable-device/success',
  disableDeviceFailed = 'devices/disable-device/failed',
  cancelDisableDevice = 'devices/disable-device/cancel',
  showDeviceDialog = 'devices/disable-device/dialog',
  showBitLockerKeys = 'devices/show-bitlocker-keys/dialog',
  getBitlockerKey = 'devices/get-bitlockerkey',
  showBitLockerRecoverKeyDialog = 'devices/show-bitlocker-recovery-key/dialog',
  getBitlockerRecoveryKey = 'devices/get-bitlocker-recovery-key',
  getDevicesAADGraph = 'devices/get-devices',
  getDevicesAADGraphResponse = 'devices/get-devices/success',
  getDevicesAADGraphFailed = 'devices/get-devices/failed'
}
